import React from 'react';
import uzb_img from "../acepts/uzb_img1.jpg";
import { NavLink } from 'react-router-dom';

function NewsImg(props) {
    return (
        <div class="card bg-dark text-white card_main" data-aos="fade-up">
        <img src={uzb_img} class="card-img" alt="..." />
        <div class="card-img-overlay">
          <h5 class="card-title fs-6"><NavLink to="/">O'zbekistan </NavLink><i class="bi bi-clock me-2"></i> <span>2022.06.20  14:17</span></h5>
          <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
        </div>
      </div>
    );
}

export default NewsImg;